import React from 'react';
import { Checkbox, SelectionControlLabel } from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { VERBIAGE } from '../../utils/consts';

const SaveGiftCardCheckbox = ({ isChecked, onChange }) => {
  const handleSaveToAccount = (event) => {
    event.stopPropagation();
    onChange(event.target.checked);
  };
  return (
    <SelectionControlLabel label={VERBIAGE.saveToAccount} data-testid="gc-save-for-future">
      <Checkbox checked={isChecked} onClick={handleSaveToAccount} data-testid="save-gc-checkbox" />
    </SelectionControlLabel>
  );
};

SaveGiftCardCheckbox.propTypes = {
  onChange: PropTypes.func,
  isChecked: PropTypes.bool
};

SaveGiftCardCheckbox.defaultProps = {
  onChange: () => {},
  isChecked: false
};

export default SaveGiftCardCheckbox;
